/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import regular from './regular';
import circular from './circular';
import icons from './icons';
import iconOnly from './iconOnly';
import minimal from './minimal';
import primary from './primary';
import rtl from './rtl';
import sizes from './sizes';
import states from './states';
import truncation from './truncation';

export default [
  primary,
  regular,
  minimal,
  sizes,
  icons,
  iconOnly,
  circular,
  truncation,
  rtl,
  states
];



// WEBPACK FOOTER //
// ./src/website/app/demos/Button/examples/index.js